import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00d2c5ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "opModal"
}
const _hoisted_2 = { class: "modalCloser" }
const _hoisted_3 = { class: "pointer ml-5" }
const _hoisted_4 = { class: "modalHeader" }
const _hoisted_5 = { class: "bigTitle text-orange" }
const _hoisted_6 = { class: "modalBody" }
const _hoisted_7 = { class: "midTitle text-center mb-2" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6 col-sm-12" }
const _hoisted_10 = { class: "col-md-6 col-sm-12" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = { class: "midTitle text-center mb-2" }
const _hoisted_13 = {
  key: 0,
  class: "fa fa-exclamation-triangle text-warning ml-1"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-sm-12" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = { class: "midTitle text-center mb-2" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_21 = {
  slot: "title",
  class: "midTitle text-center mb-2"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-sm-12" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-sm-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_personal_data = _resolveComponent("personal-data")!
  const _component_auth_data = _resolveComponent("auth-data")!
  const _component_accordion = _resolveComponent("accordion")!
  const _component_fiscal_data = _resolveComponent("fiscal-data")!
  const _component_contact_data = _resolveComponent("contact-data")!
  const _component_user_payment_data = _resolveComponent("user-payment-data")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("i", {
              class: "fa fa-times",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_localized_text, {
              localizedKey: "Dati profilo",
              text: "Dati profilo"
            })
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ml-auto",
            style: {"margin":"32px 0 0"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Salva modifiche",
              text: "Salva modifiche"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createVNode(_component_accordion, null, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Dati profilo",
                    text: "Dati profilo"
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_personal_data, {
                      value: _ctx.user.personalData
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_auth_data, {
                      value: _ctx.user.authData
                    }, null, 8, ["value"])
                  ])
                ])
              ]),
              _: 1
            }),
            _hoisted_11,
            _createVNode(_component_accordion, null, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Dati per fatturazione/ricevute",
                    text: "Dati per fatturazione/ricevute"
                  }),
                  (!_ctx.fiscalDataOk)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_fiscal_data, {
                      value: _ctx.user.fiscalData
                    }, null, 8, ["value"])
                  ])
                ])
              ]),
              _: 1
            }),
            _hoisted_16,
            _createVNode(_component_accordion, null, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Dati di contatto",
                    text: "Dati di contatto"
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_contact_data, {
                      value: _ctx.user.contactData
                    }, null, 8, ["value"])
                  ])
                ])
              ]),
              _: 1
            }),
            _hoisted_20,
            ((_ctx.user as OM.UpdateCollaboratoreVm).paymentData)
              ? (_openBlock(), _createBlock(_component_accordion, { key: 0 }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Dati per il pagamento",
                        text: "Dati per il pagamento"
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_user_payment_data, {
                          value: (_ctx.user as OM.UpdateCollaboratoreVm).paymentData
                        }, null, 8, ["value"])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary pull-right",
                  style: {"margin":"32px 0 0"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Salva modifiche",
                    text: "Salva modifiche"
                  })
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}